import { render, staticRenderFns } from "./PageItemWithSinisters.vue?vue&type=template&id=105b8c70&scoped=true"
import script from "./PageItemWithSinisters.vue?vue&type=script&lang=ts"
export * from "./PageItemWithSinisters.vue?vue&type=script&lang=ts"
import style0 from "./PageItemWithSinisters.vue?vue&type=style&index=0&id=105b8c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b8c70",
  null
  
)

export default component.exports